import { TabProps } from '@mui/material';

import { ComplianceTypes } from '@/constants';
import { IncompleteNotificationBadge } from '@/containers';

export const selectTabs = ({
  compliance,
}: {
  compliance: keyof typeof ComplianceTypes;
}): Partial<TabProps>[] => {
  return [
    { value: 'inProgress', label: 'In Progress' },
    compliance === ComplianceTypes.CPE
      ? {
          value: 'assessments',
          label: (
            <IncompleteNotificationBadge>
              Assessments
            </IncompleteNotificationBadge>
          ),
        }
      : {
          value: 'quizzes',
          label: (
            <IncompleteNotificationBadge>Quizzes</IncompleteNotificationBadge>
          ),
        },
    { value: 'bookmarked', label: 'Bookmarked' },
    { value: 'completed', label: 'Completed' },
  ];
};
